import { Suspense, lazy } from 'react';
import './App.css';
import useToken from './hooks/useToken';
import ErrorBoundary from './components/ErrorBoundary'

import Frontend from './layout/frontend'
import Backend from './layout/backend'
//import 'antd/dist/antd.css';
import 'antd/dist/reset.css';

import NoLayout from "./layout/noend";

const Registry = lazy(() => import('./layout/registry'));

function App() {
	const { user, setUser } = useToken();

    let host = window.location.hostname;
    // TEMP: hardcoded `true ||` for testing the new Registry — REMOVE AFTER TESTING
    const isRegistry = ['sna.local','sportsnutritionistregistry.com','www.sportsnutritionistregistry.com','staging.sportsnutritionistregistry.com'].includes(host);

    if(window.location.hostname == 'localhost'){
        const favicon = document.getElementById('favicon');
        favicon.href = '/images/favicon_local.png';
    }

    let pathName = window.location.pathname;
    if(pathName.substr(-1) == '/'){
        pathName = pathName.substr(0,pathName.length-1);
    }

    let publicPage = false;
    if (['/enrol', '/signUp', '/nutritionists'].some(path => pathName.startsWith(path))) {
        publicPage = true;
    }

    let mainComponent;

    if(isRegistry){
        mainComponent = <Registry/>;
	}else {

        if (window.location.pathname.substring(0, 8) === '/iframe/') {
            mainComponent = <NoLayout/>;
        }
        else if (user && !publicPage) {
            mainComponent = <Backend setUser={setUser}/>;
        } else {
            mainComponent = <Frontend/>;
        }
    }
   

    return <ErrorBoundary>
        <Suspense fallback={null}>
            {!isRegistry && <>
                <link rel="stylesheet" href="/css/bridge/stylesheet.min.css"/>
                <link rel="stylesheet" href="/css/bridge/style_dynamic.css?ver=1515643529"/>
            </>}
            {mainComponent}
        </Suspense>
    </ErrorBoundary>
}

export default App;

/*
<NavLink>
			<div>
				<ul className="header">
					<li><NavLink  exact to="/">Home</NavLink ></li>
					<li><NavLink  to="/login">Login</NavLink ></li>
				</ul>
				<div className="content">
					<Route exact path="/" component={Home}/>
					<Route path="/login/:type?" component={Login}/>
				</div>
			</div>
		</NavLink>
 */